import { useState, useEffect } from "react";

// Style
import style from "./scroll-btn.module.scss";

// Icons
import Button from "@/components/button/button";
import IconFA from "@/components/icon-fa/icon-fa";

function clickHandler(e, scrollState, sectionState) {
  e.preventDefault();
  e.stopPropagation();

  if (scrollState === "top") {
    window.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    for (let i = 0; i < sectionState.length; i++) {
      const sect = sectionState[i];
      const rect = sect.getBoundingClientRect();
      const isVisible = rect.top + rect.top / 2 < window.innerHeight; // && rect.bottom >= 0;

      let secOffset = 0;
      if (i === 2) {
        secOffset = 150;
      }

      if (!isVisible) {
        window.focus();
        window.scrollTo({
          top: rect.top + window.scrollY - secOffset,
          behavior: "smooth",
        });
        break;
      }
    }
  }
}

export default function ScrollButton() {
  const [scrollState, setScrollState] = useState("bottom");
  const [sectionState, setSectionState] = useState([]);

  // Get Sections

  useEffect(() => {
    const sections = document.querySelectorAll(
      "section, .accordion_accordionItem__5L0FJ, .archive-ingredient_indexSection__LE0Gs"
    );
    setSectionState(sections);
  }, []);

  // On Scroll
  useEffect(() => {
    const onScroll = (e) => {
      const { innerHeight, scrollY } = window;
      const scrolledTo = scrollY + innerHeight;
      const threshold = document
        .getElementById("footer")
        .getBoundingClientRect().height;
      const isPageBottom = document.body.scrollHeight - threshold <= scrolledTo;

      if (!isPageBottom) {
        setScrollState("bottom");
      } else {
        setScrollState("top");
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollState]);

  return (
    <div className={style.scrollBtn} state={scrollState}>
      <Button
        className={style.btn}
        onClick={(e) => clickHandler(e, scrollState, sectionState)}
        ariaAtts={{
          "aria-label":
            scrollState === "top"
              ? "scroll to the top of the page"
              : "scroll to the next section",
        }}
      >
        <IconFA name="faChevronDown" color="white" />
      </Button>
    </div>
  );
}
